import React, { useMemo } from 'react';

import { roomAmenityAssociationConfig } from '~/components/Accommodation/configs/amenityAssociationConfig';

import CatalogItemAssociationGrid from '../CatalogItemAssociationGrid';

interface RoomAmenitiesGridProps {
  propertyId: string;
  roomId: string;
  roomName?: string;
  isExpanded: boolean;
}

export default function RoomAmenitiesGrid({
  propertyId: _propertyId,
  roomId,
  roomName,
  isExpanded,
}: RoomAmenitiesGridProps) {
  const config = useMemo(
    () => ({
      ...roomAmenityAssociationConfig,
      associationContextName: roomName,
    }),
    [roomName],
  );

  if (!isExpanded || !roomId) {
    return null;
  }

  return <CatalogItemAssociationGrid config={config} pathParams={{ roomId }} pageSize={20} />;
}
